<template>
	<div class="t-page_profile t-work-area">
		<h1>{{ pageText.title }}</h1>
        <div>
            <div class="t-work-area__cell">
                <cmp-balance :small="false"></cmp-balance>
            </div>
            <div class="t-work-area__cell">
                <cmp-transactions :small="false"></cmp-transactions>
            </div>
        </div>
    </div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/profilePageFinance.json' : 'staticText',
        main: {
            title: "Финансы",
            code: "Активировать код"
        }
    };
    import {store} from '../../store'

    import {mapActions} from 'vuex';

    import Balance from '../../vue_components/Balance.vue'
    import Transactions from '../../vue_components/Transactions.vue'

    export default {
        data() {
            return {
                pageText: {}
            }
        },
        components: {
            'cmp-balance': Balance,
            'cmp-transactions': Transactions
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            Load(pageText, tabs){
                this.pageText = pageText;
                this.tabs = tabs;
            },
            financeLoad(){

                if(this.$route.query.page !== undefined){
                    if(parseInt(this.$route.query.page) <=1 || isNaN(parseInt(this.$route.query.page))){

                        let query = Object.assign({}, this.$route.query,  {page: undefined})
                        this.$router.replace({ name: "finance", query: query })
                    }
				}
                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
            }
        },
        beforeRouteLeave (to, from, next) {
            this.UpdatePreloadState(true);
            next();
        },
		beforeRouteUpdate (to, from, next) {
            store.dispatch('profile/LoadTransactions', to.query).then(() => {
                next(vm => vm.financeLoad())
            });
        },
        beforeRouteEnter (to, from, next) {
            let page = 1, count = 0;
            let pageText = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;
                count++;
                RunNext();
            });


            store.dispatch('staticText/LoadBalanceText').then(() => {count++;RunNext();});
            store.dispatch('staticText/LoadTransactionsText').then(() => {count++;RunNext();});
            store.dispatch('profile/LoadBalance').then(() => {
                count++;
                RunNext();
            });

            if(to.query.page !== undefined)
                if(parseInt(to.query.page) > 1)
                    page = parseInt(to.query.page);
            let query = Object.assign({}, to.query,  {page: page})

            store.dispatch('profile/LoadTransactions', query).then(() => {
                count++;
                RunNext();
            });
            store.dispatch('handbook/LoadCurrencyList').then(() => {
                count++;
                RunNext();
            });

            let RunNext = () => {
                if(count > 5)
                    next(vm => {
                        vm.Load(pageText);
                        vm.financeLoad();
                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/vue_pages/Profile/Finance.vue